module.exports = __webpack_public_path__ + "img/help-sequences.128bfa55.jpg";